/** SDK version of `@taichunmin/bitfinex` */
export const version = process?.env?.VERSION ?? 'unknown'

export { Bitfinex } from './bitfinex'

export * from './enums'
